<!--
 * @Author: your name
 * @Date: 2022-04-18 16:09:47
 * @LastEditTime: 2022-04-18 20:51:58
 * @LastEditors: Please set LastEditors
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \cacaclo_front_end\src\views\order\details\components\MTDetail.vue
-->
<template>
  <div class="main">
    <div class="back bg-white">
      <i class="el-icon-arrow-left" @click="$router.go(-1)"></i>
      {{ $t('Order.Details.Components.MTDetail.OrderInformation') }}
    </div>
    <div class="refund_reason f-b bg-white" @click="$refs.refundRecordMobile.show(product.orders.kkOrderId)" v-if="product.orders.refundStatus !== 'NULL'">
      <div style="color: #EB5757">
        <h3>{{ refundText(product.orders.refundStatus) }}</h3>
        <p>{{ `Refund Reason: ${product.orders.refundReason || ''}` }}</p>
      </div>
      <div class="f--c">
        <i class="el-icon-arrow-right"></i>
      </div>
    </div>
    <div class="status f bg-white">
      <orderStatusTag :order="product.orders"></orderStatusTag>
    </div>
    <div class="info">
      <div class="address bg-white p-r">
        <div class="f">
          <div class="el-icon-location-outline"></div>
          <div class="font">
            <div>{{ product.address.recipient }} {{ product.address.phone }}</div>
            <div>{{ product.address.street1 }} {{ product.address.street2 }}</div>
            <div>{{ product.address.city }} {{ product.address.province }} {{ product.address.country }} {{ product.address.zip }}</div>
            <div v-if="product.orders.status === 'abnormal_order'">
              <el-button v-if="product.orders.notes && product.orders.notes.code === 1" size="small" type="danger" @click="addAddressdialog">{{$t('Order.Details.Index.CompleteInformation')}}</el-button>
              <el-button v-if="product.orders.notes && [2,3].includes(product.orders.notes.code)" size="small" :loading="loading" type="primary" @click="payNowClick">{{ $t('Order.Details.Components.TopTimeLine.GetLogistics') }}</el-button>
            </div>
          </div>
        </div>
        <img src="https://img.kakaclo.com/web-img/Group1858.png" style="position: absolute; bottom: 0; left: 0; right: 0;width: 100%" />
      </div>
      <div class="orderLogistics" v-for="(packingBox, index) in product.orderLogistics" :key="index">
        <!-- 代付款、取消、已发货 不显示 -->
        <div class="common_title" v-if="!packingBox.trackingCode && ['0', '1', '6'].includes(String(product.orders.orderStatus))">{{ $t('orderDetail.NotToDeliverGoods') }}</div>
        <div class="common_title" v-else-if="!packingBox.trackingCode && ['5'].includes(String(product.orders.orderStatus))">{{ $t('Order.Details.Components.MTDetail.ShippingSoon') }}</div>
        <div class="packStatus" v-if="packingBox.omsPackId">
          <p class="title">{{ $t('Order.Details.Components.MTDetail.LogisticsInformation') }}</p>
          <div class="parcelCode">{{ $t('Order.Details.Components.MTDetail.ParcelCode') }}: {{  packingBox.omsPackId  }}</div>
          <div class="statusTag f--c" :class="{ green: packingBox.packStatus !== 'Cancelled', red: packingBox.packStatus === 'Cancelled' }">{{ packingBox.packStatus || 'Shipping' }}</div>
        </div>
        <van-divider v-if="packingBox.logisticsProviders"></van-divider>
        <div v-for="(item, pIndex) in packingBox.items" :key="pIndex">
          <OrderProduct
          :productName="item.productName"
          :color="item.color"
          :size="item.size"
          style="margin-bottom: 0.1rem"
          :image="item.imageUrl"
          :price="item.price"
          :quantity="item.productNum"
          :finalAmount="item.finalAmount"
          :product="item" />
        </div>
          <template v-if="packingBox.omsPackId">
            <div class="f-b" @click="showTracking(packingBox)" style="margin-bottom: 30px">
              <span style="color: #99c41c;font-size: 15px;">{{ $t('Order.Details.Components.MTDetail.TrackYourShipment') }}</span>
              <i class="el-icon-arrow-right"></i>
            </div>
            <div class="f-c" v-if="packingBox.packStatus !== 'Completed'">
              <el-button type="primary" style="width: 100%;height: 48px;font-size: 16px;" @click="confirmReceipt(packingBox)">{{ $t('Order.Details.Components.MTDetail.ConfirmReceipt') }}</el-button>
            </div>
          </template>
      </div>
      <div class="Information">
        <div class="Information_title common_title">{{ $t('Order.Details.Components.MTDetail.OrderInformation') }}</div>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.OrderID') }}</span>
          <span>{{ product.orders.kkOrderId }}</span>
        </div>
        <van-divider></van-divider>
        <div class="f-b" v-if="!['Kakaclo', 'kakaclo'].includes(product.orders.platformName)">
          <span>{{ $t('Order.Details.Components.MTDetail.StoreOrderID') }}</span>
          <span>{{ product.orders.orderId }}</span>
        </div>
        <van-divider v-if="!['Kakaclo', 'kakaclo'].includes(product.orders.platformName)"></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.Source') }}</span>
          <span>{{ product.orders.platformName }}</span>
        </div>
        <van-divider></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.Store') }}</span>
          <span>{{ product.orders.platformName }}</span>
        </div>
        <van-divider></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.ShippingMethod') }}</span>
          <span>{{ product.orders.channelLevel }}</span>
        </div>
        <van-divider></van-divider>
      </div>
      <div class="Information">
        <div class="Information_title common_title">{{ $t('Order.Details.Components.MTDetail.PaymentInformatio') }}</div>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.PaymentTime') }}</span>
          <span>{{ product.times.payDate && paymentMethodObjInternational ? getMoment(product.times.payDate).format('YYYY-MM-DD HH:mm:ss') : '-' }}</span>
        </div>
        <van-divider></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.PaymentMethod') }}</span>
          <span>{{ product.times.payDate && paymentMethodObjInternational ? paymentMethodObjInternational : '-' }}</span>
        </div>
        <van-divider></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.Subtotal') }}</span>
          <span>US ${{ product.pays.skusAmount }}</span>
        </div>
        <van-divider></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.Delivery') }}</span>
          <span>US ${{ product.pays.freightAmount }}</span>
        </div>
        <van-divider></van-divider>

        <!-- 优惠码金额 -->
        <div class="f-b" @click="onShowCouponAmount">
          <span>Promo code</span>
          <span><span style="color: #ab1e1a;">- US ${{ product.pays.couponAmount }}</span> <i v-if="product.pays.couponAmount > 0" class="el-icon-arrow-right"></i></span>
        </div>

        <van-divider></van-divider>
        <!-- 优惠券金额 -->
        <div class="f-b" @click="onShowCouponTicketAmount">
          <span>Coupon</span>
          <span><span style="color: #ab1e1a;">- US ${{ product.pays.couponTicketAmount }}</span> <i v-if="product.pays.couponTicketAmount" class="el-icon-arrow-right"></i></span>
        </div>
        <van-divider></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.Total') }}</span>
          <span>US ${{ product.pays.totalAmount }}</span>
        </div>
        <van-divider></van-divider>
        <div class="f-b">
          <span>{{ $t('Order.Details.Components.MTDetail.PaymentAmount') }}</span>
          <span>US ${{ product.pays.finalAmount }}</span>
        </div>
        <van-divider></van-divider>
      </div>
    </div>
    <div class="orderHandleBtn">
      <div v-if="showStatus === 'waiting_to_ship'" class="f-c">
        <!-- 退款按钮 -->
        <el-button @click="handleRefund">{{ $t('orderDetail.ApplyRefund') }}</el-button>
      </div>
      <div v-if="showStatus === 'waiting_payment'" class="f-c">
        <el-button  @click="cancelOrder" class="link_button" >{{ $t('orderList.CancelOrder') }}</el-button>
      </div>
      <template v-if="product.orders.status !== 'abnormal_order'">
        <template v-if="product.orders.refundStatus !== 'refunded'">
          <div v-if="!['waiting_payment', 'waiting_to_ship', 'cancel'].includes(showStatus)" class="f-c">
            <el-button @click="orderDownloadInvoice" >{{ $t('Order.Details.Components.MTDetail.Invoice') }}</el-button>
          </div>
        </template>
      </template>

      <template v-if="0 && product.orders.status === 'abnormal_order'">
        <div class="tips">Please go to PC to complete information</div>
      </template>
    </div>
    <div class="bottomBtn bg-white f-c-c" v-if="showStatus === 'waiting_payment'">
      <el-button @click="checkEmailBind" type="primary">{{ $t('Order.Details.Components.MTDetail.PayNow') }}</el-button>
    </div>
    <div class="bottom_fill_space bg-white"></div>
    <trackingDialog ref="trackingDialog"></trackingDialog>
    <cancelRefundDialogVue ref="cancelRefundDialogVue" @reFresh="$emit('reFresh')"></cancelRefundDialogVue>
    <refundRecordMobile ref="refundRecordMobile"></refundRecordMobile>

    <!-- 显示优惠码金额弹窗 -->
    <VanPopup v-model="showCouponAmount" closeable position="bottom" :style="{ height: '38%' }">
      <p class="top-Tips">Promo Code</p>
      <div class="bottom-promo-code">
        <p class="used-tips">{{ `Promo Code: ${promoCode.couponCode}` }}</p>
        <div class="choose-to-use">
          <i class="el-icon-s-ticket" />
          <span class="get-info">
            <strong class="get">{{ getOfferDisplayText }}</strong>
            <span class="discount">{{ `${promoCode.discountRule === 1 ? `${promoCode.discountPercent && promoCode.discountPercent.toFixed(2)}% off` : `$${promoCode.discountFixed && promoCode.discountFixed.toFixed(2)}`}` }}</span>
          </span>
        </div>
      </div>
    </VanPopup>

    <!-- 显示优惠券金额弹窗 -->
    <VanPopup v-model="showCouponTicketAmount" closeable position="bottom" :style="{ height: '38%' }">
      <p class="top-Tips">Coupon</p>
      <div class="bottom-promo-code">
        <CouponItem :coupon="coupon" class="coupon-item" />
      </div>
    </VanPopup>

    <van-popup v-model="show" round position="bottom" :style="{ height: '30%'}" @close="closePopup">
      <div v-for="(items, index) in this.channelList" :key="index">
        <div v-for="(item, index1) in items.data" :key="'list-' + index1" style="padding: 20px;border: 1px solid #99C41C;color: #99C41C;  margin: 20px 20px 10px;">
          <el-radio checked="checked"></el-radio>{{ item.agingGrade }}({{ item.deliveryTime }}, ${{ item.estimatedFreight }})
        </div>
      </div>
    </van-popup>

    <AddressDialog ref="addressdialog" :addForm="addressForm" :isOrderAddress="true" @orderAddressChange="orderChangeAddress"></AddressDialog>

    <!-- 设置账号 -->
    <AccountSetting ref="accountSetting" @setSuccess="setSuccess"></AccountSetting>
  </div>
</template>

<script>
import VanPopup from 'vant/lib/popup'
import 'vant/lib/popup/style'

import AddressDialog from '@/views/commodity/components/AddressDialog'

import CouponItem from '@/components/CouponItem.vue'

import Divider from 'vant/lib/divider'
import 'vant/lib/divider/style'
import OrderProduct from '@/components/mobile/OrderProduct.vue'
import trackingDialog from '../../list/components/trackingDialog.vue'
import orderStatusTag from '@/views/order/list/components/orderStatusTag.vue'
import moment from 'moment'
import API from '@/api'
import { downloadBlobFile } from '@/util/index.js'
import cancelRefundDialogVue from '@/views/order/list/components/cancelRefundDialog.vue'
import refundRecordMobile from './refundRecordMobile.vue'
import AccountSetting from '@/views/personal-center/account-setting/components/AccountSetting.vue'

export default {
  props: {
    product: {
      type: Object,
      default: () => ({
        orders: {}
      })
    },
    promoCode: {
      type: Object,
      required: false,
      default: () => ({})
    },
    coupon: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  components: {
    'van-divider': Divider,
    VanPopup,
    CouponItem,
    OrderProduct,
    trackingDialog,
    orderStatusTag,
    cancelRefundDialogVue,
    refundRecordMobile,
    AddressDialog,
    AccountSetting
  },
  filters: {
    paymentMethodFont(value) {
      const obj = {
        0: this.$t('orderDetail.Balance'),
        1: this.$t('orderDetail.CreditCard'),
        2: 'Paypal'
      }
      console.log(obj)
      return obj[value]
    }
  },
  computed: {
    getOfferDisplayText() {
      switch (this.promoCode.discountCondition) {
        case 0: // 无门槛
          return `Get `
        case 1: // 消费满件数
          return `Spend `
        case 2: // 消费满金额
          return `Get `
        default:
          return '-'
      }
    },
    paymentMethodObjInternational() {
      const obj = { 0: this.$t('orderDetail.Balance'), 1: this.$t('orderDetail.CreditCard'), 2: 'Paypal', 3: 'Other payment Airwallex', 9: 'Payoneer' }
      const balance = this.$store.state.common.balance
      if (balance && balance < this.product.pays.totalAmount) {
        return '-'
      }
      if (this.product.pays) {
        return obj[this.product.pays.paymentMethod]
      }
      return '-'
    },
    attachmentSkuVosAll() {
      let arr = []
      this.product.orderLogistics.forEach((e) => {
        e.items.forEach((ee) => {
          if (!ee.attachmentSkuVos) return
          ee.attachmentSkuVos.forEach((eee) => {
            let obj = {
              imageUrl: eee.imageUrl,
              id: eee.id,
              name: eee.name,
              productNum: ee.productNum
            }
            let index = arr.findIndex((a) => a.name === eee.name)
            if (index !== -1) {
              arr[index].productNum += ee.productNum
            } else {
              arr.push(obj)
            }
          })
        })
      })
      return arr
    },
    showStatus() {
      if (['waiting_payment', 'completed', 'cancel'].includes(this.product.orders.status)) return this.product.orders.status
      if (this.product.orders.status === 'abnormal_order') return this.product.orders.financialStatus
      if (this.product.orders.status === 'processing') return this.product.orders.fulfillmentStatus
      return 'NULL'
    },
    getMoment() {
      return moment
    }
  },
  data() {
    return {
      showCouponAmount: false,
      showCouponTicketAmount: false,
      loading: false,
      show: false,
      addressForm: {
        id: this.product.orders.kkOrderId,
        fullName: this.product.address.recipient,
        phoneNumber: this.product.address.phone,
        streetAddressLine1: this.product.address.street1,
        streetAddressLine2: '',
        city: this.product.address.city,
        province: this.product.address.province,
        countryCode: this.product.address.country,
        zipCode: '123123',
        vatCode: ''
      },
      channelList: []
    }
  },
  methods: {
    refundText(value) {
      if (value === 'refunding') return this.$t('Order.Details.Components.MTDetail.Refunding')
      if (value === 'partial_refund') return this.$t('Order.Details.Components.MTDetail.PartialRefund')
      if (value === 'refunded') return this.$t('Order.Details.Components.MTDetail.Refunded')
      return ''
    },
    /**
     * 显示优惠码金额弹窗
     */
    onShowCouponAmount() {
      if (this.product.pays.couponAmount > 0) {
        this.showCouponAmount = true
      }
    },

    /**
     * 显示优惠券金额弹窗
     */
    onShowCouponTicketAmount() {
      if (this.product.pays.couponTicketAmount > 0) {
        this.showCouponTicketAmount = true
      }
    },

    addAddressdialog() {
      this.addressForm = {
        id: this.product.orders.kkOrderId,
        fullName: this.product.address.recipient,
        phoneNumber: this.product.address.phone,
        streetAddressLine1: this.product.address.street1,
        streetAddressLine2: '',
        city: this.product.address.city,
        province: this.product.address.province,
        countryCode: this.product.address.country,
        zipCode: this.product.address.zip,
        vatCode: ''
      }
      // console.log(this.addressForm)
      // this.$set(this, 'addressForm', this.addressForm)
      this.$refs.addressdialog.show()
    },
    orderChangeAddress(addressForm) {
      return new Promise((resolve, reject) => {
        const { countryCode: country, city, phoneNumber: phone, fullName: recipient, streetAddressLine1: street1, streetAddressLine2: street2, province, zipCode: zip } = addressForm
        const params = {
          data: {
            orderAddresses: {
              country,
              city,
              phone,
              recipient,
              street1,
              street2,
              province,
              zip
            },
            paymentMethod: 0
          },
          kkOrderId: this.product.orders.kkOrderId
        }
        API.orderChangeAddress(params).then(res => {
          if (res.code !== 10000) {
            return this.$message.error(res.message)
          }
          // this.addressForm = {}
          // this.getOrderInfo().then(() => {
          //   this.getChannelList().then(() => {
          //     this.submitChannel(this.channelActive).then(() => {
          //       this.getOrderInfo()
          //     })
          //   })
          // })
          location.reload()
          resolve()
        }).catch(err => {
          console.log(err)
          this.$message.error(err.data.data)
          this.channelList = []
          reject()
        })
      })
    },

    checkEmailBind() {
      if (!this.$store.state.common.email) {
        this.$refs.accountSetting.show('bindEmail')
      } else {
        this.payNow()
      }
    },
    setSuccess() {
      this.payNow()
    },

    payNow() {
      this.$emit('payNow')
    },
    showTracking(item) {
      this.$router.push({
        path: '/order/trackingInfo',
        query: {
          omsPackId: item.omsPackId,
          packStatus: item.packStatus,
          tailTrackingCode: item.tailTrackingCode
        }
      })
    },

    payNowClick() {
      this.loading = true
      return new Promise((resolve, reject) => {
        API.orderGetDetailToPay(this.product.orders.kkOrderId).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          // res.data.logistics && res.data.logistics.forEach((item, i) => {
          //   this.$set(item, 'channelList', [])
          //   if (this.channelList.length) {
          //     this.channelList.forEach(e => {
          //       if (e.code === 10000 && e.data && e.data.length && e.warehouseCode === item.warehouseCode) {
          //         this.$set(item, 'channelList', e.data)
          //       }
          //     })
          //   }
          // })
          this.orderInfo = res.data
          // const { address } = this.orderInfo
          // let selectAddressIndex = this.addressList.findIndex(e => {
          //   let checkWay = [address.country === e.countryCode, address.city === e.city, +address.phone === +e.phoneNumber, address.street1 === e.streetAddressLine1]
          //   return checkWay.every(e => e)
          // })
          // this.selectAddressIndex = selectAddressIndex > 0 ? selectAddressIndex : 0
          // this.channelActive = this.orderInfo.orders.channelCode
          // this.warehouseChannelList = this.orderInfo.logistics.map(item => ({ isExpress: item.isExpress, warehouseCode: item.warehouseCode, channelCode: item.channelCode }))
          // this.radioValue = this.orderInfo.pays.paymentMethod
          // this.$store.dispatch('common/getBalance').then(balance => {
          //   this.balance = balance
          //   if (this.balance < this.orderInfo.pays.totalAmount) {
          //     this.radioValue = 2
          //   }
          // })
          this.getLogisticsChannels()
          resolve()
        }).finally(() => {
          this.loading = false
        })
      })
    },
    getLogisticsChannels() {
      return new Promise((resolve, reject) => {
        const params = {
          warehouses: [],
          currency: 'USD'
        }
        let address = this.addressForm
        this.orderInfo.logistics && this.orderInfo.logistics.forEach(item => {
          params.warehouses.push({
            termini: this.orderInfo.address.country,
            warehouseCode: item.warehouseCode,
            products: this.orderInfo.orderItems.filter(p => p.warehouseCode === item.warehouseCode).map(e => {
              return {
                skuCode: e.skuCode,
                quantity: e.productNum,
                kkProductId: e.kkProductId
              }
            }),
            province: address.province || undefined,
            city: address.city || undefined,
            zipCode: address.zip || undefined,
            street1: address.street1 || undefined,
            street2: address.street2 || undefined,
            platformCode: this.orderInfo.orders && this.orderInfo.orders.platformCode
          })
        })

        this.deliveryLoading = true
        API.getLogisticsChannel(params).then(res => {
          if (res.code !== 10000) return this.$message.error(res.message)
          this.channelList = res.data
          this.show = true
          resolve()
          // this.loading = false
        }).finally(() => {
          this.deliveryLoading = false
        })
      })
    },

    closePopup() {
      location.reload()
    },

    /**
     * 退款按钮的点击事件
     */
    handleRefund() {
      this.$router.push(`/order/refund?kakaOrderId=${this.$route.query.kkOrderId}`)
    },
    confirmReceipt(packingBox) {
      API.orderReceipt(packingBox.omsPackId)
        .then((res) => {
          this.$message.success(res.message)
          this.$emit('reFresh')
        })
        .catch((err) => {
          let message = err.message || err.data.message
          this.$message.error(message)
        })
    },
    orderDownloadInvoice() {
      API.orderDownloadInvoice(this.product.orders.kkOrderId)
        .then((res) => {
          downloadBlobFile(res, `发票.pdf`)
        })
        .catch((err) => {
          downloadBlobFile(err.data, `发票.pdf`)
        })
    },
    cancelOrder() {
      // this.$refs.cancelRefundDialogVue.show(this.product.orders.kkOrderId)
      this.$router.push({
        path: '/order/cancelMT',
        query: {
          kkOrderId: this.product.orders.kkOrderId
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.used-tips {
  color: #8B93A3;
  margin-bottom: 10px;
}

.top-Tips {
  font-size: 14px;
  font-weight: 700;
  margin-top: 16px;
  margin-bottom: 22px;
  padding-left: 16px;
}

.bottom-promo-code {
  padding: 0 16px;
  .choose-to-use {
    display: flex;
    width: 100%;
    height: 32px;
    margin: 0 auto;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    border: 1px solid #e3444e;
    background: rgba(227, 68, 78, 0.03);
    .icon-youhuiquan {
      color: #E3444E;
      font-size: 20px;
    }
    .get-info {
      margin-left: 5px;
      .get {
        color: #10141D;
      }
      .discount {
        color: #E3444E;
      }
    }
  }
}

.el-icon-s-ticket {
  color: #E3444E;
  margin-left: 5px;
}

.tips {
  color: #7b7b7b;
  font-size: 12px;
  text-align: center;
}

.main {
  .back {
    color: #7b7b7b;
    padding: 0.2rem;
    font-size: 0.3rem;
  }
  .status {
    padding: 0.1rem 10px 0.1rem 20px;
    margin: 0.2rem 0;
  }
  .info {
    .common_title {
      font-weight: bold;
      line-height: 0.8rem;
      font-size: 0.3rem;
    }
    .address {
      margin-bottom: 0.2rem;
      .el-icon-location-outline {
        padding-top: 0.1rem;
        width: 0.4rem;
      }
      .font {
        color: gray;
        line-height: 0.4rem;
      }
    }
    > div {
      padding: 0.2rem 0.3rem;
      background-color: #ffffff;
      margin-bottom: 6px;
    }
    .Information {
    }
    .orderLogistics {
      .packStatus {
        margin-bottom: 10px;
        .title {
          font-size: 0.32rem;
          font-weight: 500;
          margin-bottom: 4px;
        }
        .statusTag::before {
          content: '';
          display: block;
          margin-right: 4px;
          width: 0.15rem;
          height: 0.15rem;
          line-height: 28px;
          border-radius: 100%;
        }
        .green {
          color: #99c41c;
        }
        .green::before {
          background-color: #99c41c;
        }
        .red {
          color: #ab1e1a;
        }
        .red::before {
          background-color: #ab1e1a;
        }
        .parcelCode{
          font-size: 14px;
          color: #10141D;
          font-weight: 400;
          margin-bottom: 4px;
        }
        .statusTag{
          padding-left: 86px;
        }
      }
    }
  }
  .bottom_fill_space {
    height: 2rem;
    width: 100%;
  }
  .bottomBtn {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    height: 1rem;
    /deep/.el-button {
      width: 6rem;
      height: 0.8rem;
    }
  }
  .refund_reason{
    margin: 10px 0 6px;
    padding: .2rem .3rem;
  }
}
.contentBox {
  background-color: white;
  margin: 10px 0;
}
.address {
  margin-bottom: 0.2rem;
  .el-icon-location-outline {
    padding-top: 0.1rem;
    width: 0.4rem;
  }
  .font {
    color: gray;
    line-height: 0.4rem;
  }
}
.common_title {
  font-weight: bold;
  line-height: 0.8rem;
  font-size: 0.3rem;
}
.commonPadding {
  padding: 0.2rem 0.3rem;
}
.orderHandleBtn{
  margin-top: 10px;
  >div{
    margin-bottom: 10px;
    .el-button{
      height: 48px;
      font-size: 16px;
      width: 90%;
    }
  }
}
</style>
